'use client'

import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'
import { RiMoonFill, RiSunFill } from 'react-icons/ri'

export default function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return <div className="w-9 h-9 rounded-sm animate-pulse" />
  }

  const isDark = resolvedTheme === 'dark'
  const otherTheme = isDark ? 'light' : 'dark'

  return (
    <button
      type="button"
      aria-label={`Switch to ${otherTheme} theme`}
      onClick={() => setTheme(otherTheme)}
      className="relative rounded-sm p-2 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus:outline-none"
    >
      {/* Sun icon for light mode */}
      <RiSunFill
        className={`h-5 w-5 transition-all duration-300 ${
          isDark
            ? 'opacity-0 rotate-90 scale-0'
            : 'opacity-100 rotate-0 scale-100'
        }`}
      />

      {/* Moon icon for dark mode */}
      <RiMoonFill
        className={`absolute inset-0 m-auto h-5 w-5 transition-all duration-300 ${
          isDark
            ? 'opacity-100 rotate-0 scale-100'
            : 'opacity-0 -rotate-90 scale-0'
        }`}
      />

      <span className="sr-only">
        {isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      </span>
    </button>
  )
}
